import React from 'react';
import { FormSpy } from 'react-final-form';
import { SendByType } from '../../invoices/book-and-send/types';
import { DialogContentDrawerRenderProps } from '@economic/taco';

interface Props {
    drawer: DialogContentDrawerRenderProps;
    isBulkSending?: boolean;
}

const SpyComponent = ({ type, openDrawer, closeDrawer, isDrawerOpen, isBulkSending }) => {
    React.useEffect(() => {
        if (type === SendByType.email) {
            openDrawer();
        } else if (type === SendByType.oioxml && !isBulkSending) {
            openDrawer();
        } else if (isDrawerOpen) {
            closeDrawer();
        }
    }, []);

    return null;
};

export function AutoCloseDrawer({ drawer, isBulkSending = false }: Props) {
    const openDrawer = () => {
        if (!drawer.open) {
            drawer.toggle();
        }
    };
    const closeDrawer = () => {
        if (drawer.open) {
            drawer.toggle();
        }
    };

    return (
        <FormSpy
            subscription={{ values: true }}
            component={({ values }) => (
                <SpyComponent
                    type={values.sendByType}
                    isDrawerOpen={drawer.open}
                    openDrawer={openDrawer}
                    closeDrawer={closeDrawer}
                    isBulkSending={isBulkSending}
                />
            )}
        />
    );
}
